import API_GATEWAY from "@/services/config/main-axios";

const userInfoService = {
  getAllAdmins(filters) {
    return API_GATEWAY.get("backoffice/userInfo/getAllUsers", {
      params: filters
    });
  },

  createNewRole(roleInfo) {
    return API_GATEWAY.post("backoffice/userInfo/assignRoleAction", roleInfo);
  },

  editUserRoles(roleInfo) {
    return API_GATEWAY.post("backoffice/userInfo/assignUserRoles", roleInfo);
  },

  getAllRoles() {
    return API_GATEWAY.get("backoffice/userInfo/getAllRoles");
  },

  getUserRoles(userId) {
    return API_GATEWAY.get("backoffice/userInfo/getUserRoles", {
      params: userId
    });
  },

  getAllActions() {
    return API_GATEWAY.get("backoffice/userInfo/getAllActions");
  },

  getRoleActions(roleName) {
    return API_GATEWAY.get(
      `backoffice/userInfo/getAllActionsByRoleName/${roleName}`
    );
  }
};

export default userInfoService;
